export default {
  title: {
    index: 'My Referrals',
    potential: 'Potential Candidate',
    applied: 'Applied Candidate',
    hidden: 'Hidden Candidate'
  },
  menu: {
    index: 'Leads',
    potential: 'Potential',
    applied: 'Applied',
    hidden: 'Hidden'
  },
  label: {
    top: 'Top',
    myLeads: 'Leads',
    switchActive: 'Hide',
    switchInactive: 'Unhide',
    today: 'Today',
    yesterday: 'Yesterday'
  },
  message: {
    shareTip: 'If this person is a direct connection of yours, you can tap the icon to share the JD with them again, and encourage them (or their friend) to apply!',
    leadNoData: 'Currently there are no leads. Please start sharing!',
    appliedNoData: 'Currently there are no applicants. Please start sharing!',
    optionSuccess: 'Option Success'
  },
  btn: {
    moveAction: {
      removeTop: 'Remove Top',
      pinTop: 'Pin Top',
      hide: 'Hide',
      moveToPotential: 'Move to Potential'
    }
  },
  reward: {
    potential: 'Potential'
  }
}
